import { Link } from "react-router-dom";
import founderImg from "../../assets/founder.png";

export const AboutFounder = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-50 via-white to-sea-50 py-20 sm:py-24">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-brand-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-sea-100/60 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <div>
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600">
            About Founder
          </span>
          <h2 className="mt-3 font-display text-4xl font-semibold text-slate-900 sm:text-5xl">
            Snehal Jadhav – Ghegadmal
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            Mrs. Snehal has a deep passion for helping people on their
            emotional impact which sometimes leads to significant life changes
            such as relationships conflict, anxiety, depression from physical
            or mental injury, loss and separation of a loved ones. Her
            Counselling has helped many people to heal mental &amp; emotional
            wounds, they reconnected with life and are leading the desired
            life.
          </p>
          <div className="mt-8">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-full bg-brand-700 px-8 py-4 text-sm font-bold tracking-widest text-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:bg-brand-800 hover:shadow-xl"
            >
              ABOUT US
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2.5}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-md">
          <div className="absolute inset-0 -rotate-3 rounded-[2.5rem] bg-gradient-to-br from-brand-200 to-sea-200" />
          <img
            src={founderImg}
            alt="Founder Snehal Jadhav – Ghegadmal"
            className="relative w-full rotate-1 rounded-[2.5rem] object-cover shadow-soft transition-transform duration-500 hover:rotate-0"
          />
        </div>
      </div>
    </section>
  );
};
